import React from 'react';
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import ErrorBoundary from '../components/ErrorBoundary/ErrorBoundary';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import FooterMax from '../components/FooterMax';
import SectionOne from '../components/SectionOne';
import SectionTwo from '../components/SectionTwo';
import SectionFour from '../components/SectionFour';
import SectionSix from '../components/SectionSix';
import "../css/Home.css";

export default function About() {
  const navigate = useNavigate();
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams("fa");

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
        navigate(`/fa`); 
      } else {
        setLang(`en`);
        navigate(`/en`); 
      }
    } else {
      setLang(lang)
      navigate(`/${lang}`); 
    }
  }, [lang])

  return (
    <>
      <ErrorBoundary>
        <NavbarLog />
          <SectionSix  setlang={setlang}/>
        <FooterMax />
      </ErrorBoundary>
    </>
  );
}